/**
 * Apple Pay API
 * Merchant validation and token updates
 */

import { browserContext } from '../utils/platform';
import { apiRequest } from './core';

// ============================================================================
// API Functions
// ============================================================================

/**
 * Validate Apple Pay merchant session
 * Called during ApplePaySession's onvalidatemerchant callback
 *
 * @param paymentSourceId - The payment source ID
 * @param validationUrl - The validation URL provided by Apple
 */
export const validateApplePayMerchant = async (
  paymentSourceId: number,
  validationUrl: string,
  fxRate?: number,
  currency?: string
): Promise<any> => {
  const requestBody: Record<string, unknown> = {
    payment_source_id: paymentSourceId,
    payment_session_url: validationUrl,
    ...(currency && { currency }),
    ...(fxRate && { fx_rate: fxRate })
  };

  return apiRequest<any>(
    '/my/apple_pay_sessions',
    {
      method: 'POST',
      body: requestBody
    }
  );
};

/**
 * Update payment source with Apple Pay token
 * Called after Apple Pay authorization to save the payment token
 *
 * @param paymentSourceId - The payment source ID
 * @param token - Apple Pay payment token
 * @param billingContact - Billing contact info from Apple Pay
 * @param shippingContact - Shipping contact info from Apple Pay
 */
export const updateApplePayToken = async (
  paymentSourceId: number,
  token: any,
  billingContact?: any,
  shippingContact?: any
): Promise<any> => {
  const requestBody = {
    context: {
      validate_card: true,
      token,
      billingContact,
      shippingContact
    },
    ...browserContext
  };

  return apiRequest<any>(
    `/my/payment_sources/${ paymentSourceId }`,
    {
      method: 'PUT',
      body: requestBody
    }
  );
};
